import React from "react";
import DefaultAppBar from "../nav/AppBar";
import { useMediaQuery, useTheme } from "@mui/material";
import VerticalDivider from "../VerticalDivider";

const DefaultLayout = ({
  children,
  hideAppBar,
}: {
  children: React.ReactNode;
  hideAppBar?: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="app-default-layout">
      {hideAppBar ? null : (
        <div>
          {isMobile ? (
            <DefaultAppBar />
          ) : (
            <div style={{ maxWidth: "1440px", margin: "0 auto" }}>
              <DefaultAppBar />
            </div>
          )}
        </div>
      )}
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "fixed",
            margin: "0 auto",
            width: "100%",
            maxWidth: "1440px",
            backgroundColor: "transparent",
            zIndex: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              height: "100vh",
              width: "100%",
            }}
          >
            <VerticalDivider />
            <VerticalDivider />
            <VerticalDivider />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: isMobile ? "16px" : undefined,
            paddingRight: isMobile ? "16px" : undefined,
          }}
        >
          <div style={{ zIndex: 1 }}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
